export default __webpack_public_path__ + "static/media/ST.bc4caef7.svg";